var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApEmergencyLightingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.87 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.87 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.734,45.047H37.766a2.491,2.491,0,0,0,2.484-2.484V39.5a2.491,2.491,0,0,0-2.484-2.491H37.55v-1.44a4.183,4.183,0,0,0-3.038-4.018V22.1a7.79,7.79,0,0,0-15.581,0v9.475a4.183,4.183,0,0,0-2.981,4.018v1.44h-.216a2.491,2.491,0,0,0-2.484,2.491v3.06A2.491,2.491,0,0,0,15.734,45.047ZM26.75,15.75A6.358,6.358,0,0,1,33.1,22.1v9.317H27.47v-5.99a2.491,2.491,0,0,0,.986.209A2.426,2.426,0,1,0,26.75,21.5a2.421,2.421,0,1,0-1.706,4.133,2.491,2.491,0,0,0,.986-.209v5.99H20.4V22.1A6.358,6.358,0,0,1,26.75,15.75Zm.72,7.459a.994.994,0,1,1,.986.958.994.994,0,0,1-.986-.958Zm-1.44,0a.994.994,0,1,1-.986-.986.994.994,0,0,1,.986.986ZM17.39,35.593a2.736,2.736,0,0,1,2.736-2.736H33.4a2.736,2.736,0,0,1,2.736,2.736v1.44H17.39Zm-2.7,3.91a1.051,1.051,0,0,1,1.044-1.051H37.766A1.051,1.051,0,0,1,38.81,39.5v3.06a1.044,1.044,0,0,1-1.044,1.044H15.734a1.044,1.044,0,0,1-1.044-1.044Z",
    transform: "translate(-12.256 -9.047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,7.72V9.038a.72.72,0,0,0,1.44,0V7.72a.72.72,0,1,0-1.44,0Z",
    transform: "translate(-17.226 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.009,12.044A.729.729,0,0,0,41,11.778l.655-1.138A.72.72,0,0,0,40.4,9.92l-.662,1.138a.72.72,0,0,0,.266.986Z",
    transform: "translate(-19.647 -7.724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.454,16.922a.72.72,0,0,0-.979-.259l-1.145.655a.72.72,0,1,0,.72,1.246l1.145-.655a.72.72,0,0,0,.259-.986Z",
    transform: "translate(-21.411 -9.679)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.938,34.873l-1.145.662a.719.719,0,0,0,.72,1.246l1.145-.655a.722.722,0,1,0-.72-1.253Z",
    transform: "translate(-12.59 -14.777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.058,26.85a.72.72,0,0,0-.72-.72H49.02a.72.72,0,1,0,0,1.44h1.318A.72.72,0,0,0,51.058,26.85Z",
    transform: "translate(-22.07 -12.356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.59,27.57h1.318a.72.72,0,0,0,0-1.44H12.59a.72.72,0,0,0,0,1.44Z",
    transform: "translate(-11.87 -12.356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.082,35.14a.72.72,0,0,0,.259.986l1.145.655a.719.719,0,0,0,.72-1.246l-1.145-.662A.72.72,0,0,0,46.082,35.14Z",
    transform: "translate(-21.422 -14.778)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.656,17.318l-1.145-.655a.719.719,0,0,0-.72,1.246l1.145.655a.72.72,0,0,0,.72-1.246Z",
    transform: "translate(-12.588 -9.679)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,9.663a.72.72,0,0,0-.266.979l.655,1.138a.722.722,0,1,0,1.253-.72l-.662-1.138A.72.72,0,0,0,21.8,9.663Z",
    transform: "translate(-14.549 -7.719)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApEmergencyLightingIcon);
export default __webpack_public_path__ + "static/media/ap-emergency-lighting-icon.4d93bc17f1a56bab79577558608ff8b5.svg";
export { ForwardRef as ReactComponent };